import AliceImg from '@/images/team/alice.webp';
import JamieImg from '@/images/team/jamie.webp';
import JonImg from '@/images/team/jon.webp';
import JordanImg from '@/images/team/jordan.webp';
import JoshImg from '@/images/team/josh.webp';
import MaxImg from '@/images/team/max.webp';
import SamImg from '@/images/team/sam.webp';
import ShubhamImg from '@/images/team/shubham.webp';
import WynImg from '@/images/team/wyn.webp';
import { m } from '@/paraglide/messages';
import type { MessageFunction } from '@/paraglide/runtime';

// cspell:ignore Shubham

export interface TeamMember {
  name: string;
  role: MessageFunction;
  photo?: string;
  linkedin?: string;
}

// The team in the order they appear. Photos and LinkedIn links are added as they become available.
export const team: TeamMember[] = [
  {
    name: 'Wyn',
    role: m.team_role_managing_director,
    photo: WynImg,
    linkedin: 'https://www.linkedin.com/in/wyn-price-49b4b819',
  },
  {
    name: 'Jon',
    role: m.team_role_systems_director,
    photo: JonImg,
    linkedin: 'https://www.linkedin.com/in/jon-gaskell-81269479',
  },
  {
    name: 'Joshua',
    role: m.team_role_operations_director,
    photo: JoshImg,
    linkedin: 'https://www.linkedin.com/in/josh-price-9a322a312',
  },
  { name: 'Jamie', role: m.team_role_operations_coordinator, photo: JamieImg },
  {
    name: 'Jordan',
    role: m.team_role_media,
    photo: JordanImg,
    linkedin: 'https://www.linkedin.com/in/jordan-price-6a69a0195',
  },
  { name: 'Sam', role: m.team_role_data_analytics, photo: SamImg },
  {
    name: 'Shubham',
    role: m.team_role_marine_consultant,
    photo: ShubhamImg,
    linkedin: 'https://www.linkedin.com/in/shubham912',
  },
  { name: 'Alice', role: m.team_role_compliance, photo: AliceImg },
  {
    name: 'Maxwell',
    role: m.team_role_software_developer,
    photo: MaxImg,
    linkedin: 'https://www.linkedin.com/in/maxwellweru',
  },
];
